module.exports = __webpack_public_path__ + "static/media/unlimited_svg.d392e670.svg";